'use client';
import { motion } from 'framer-motion';
import { Portal, Text, useDisclosure, VStack } from '@chakra-ui/react';

import NextImage from 'shared/NextImage';
import { goTo } from 'shared/lib';

import TOC from 'assets/icons/toc.svg';
import Cross from 'assets/icons/Cross.svg';

const animationDuration = 0.4;

const MobileTableOfContents = ({ navButtonsData }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Portal>
      <VStack
        pos="fixed"
        zIndex="1099"
        inset={{ mobile: 'auto auto 16px 16px', tablet: 'auto auto 20px 20px' }}
        w={
          isOpen
            ? { mobile: 'calc(100vw - (16px * 2))', tablet: 'calc(100vw - (20px * 2))' }
            : { mobile: '56px', tablet: '64px' }
        }
        h={isOpen ? `${88 + navButtonsData.length * 41}px` : { mobile: '56px', tablet: '64px' }}
        align="start"
        p={isOpen ? '24px' : '16px'}
        gap="12px"
        border="1px solid"
        borderColor="text.darkGray"
        borderRadius={isOpen ? '32px' : '12px'}
        bg="rgba(255, 255, 255, 0.50)"
        backdropFilter="blur(20px)"
        cursor={isOpen ? 'default' : 'pointer'}
        transition={`all ${animationDuration}s`}
        overflow="hidden"
        onClick={isOpen ? undefined : onOpen}
      >
        <Icon
          icon={Cross}
          iconProps={{ boxSize: { mobile: '30px', tablet: '32px' } }}
          inset="24px 24px auto auto"
          motionProps={{
            animate: { opacity: isOpen ? 1 : 0, pointerEvents: isOpen ? 'all' : 'none' },
            transition: {
              duration: animationDuration / 2,
              delay: isOpen ? animationDuration / 2 : 0,
            },
            onClick: onClose,
          }}
        />

        <Icon
          icon={TOC}
          iconProps={{ boxSize: { mobile: '24px', tablet: '30px' } }}
          inset="16px 16px auto auto"
          motionProps={{
            animate: { opacity: isOpen ? 0 : 1, pointerEvents: isOpen ? 'none' : 'all' },
            transition: {
              duration: animationDuration / 2,
              delay: isOpen ? 0 : animationDuration / 2,
            },
            onClick: onClose,
          }}
        />

        <Text
          textStyle="header.h4"
          fontSize="24px"
          opacity={isOpen ? '1' : '0'}
          pointerEvents={isOpen ? 'all' : 'none'}
          transition={`all ${animationDuration}s`}
        >
          Содержание
        </Text>

        <VStack
          w="full"
          align="start"
          gap="4px"
          color="text.steelGray"
          opacity={isOpen ? '1' : '0'}
          pointerEvents={isOpen ? 'all' : 'none'}
          transition={`all ${animationDuration}s`}
          // @ts-ignore
          onClick={e => goTo(e.target.dataset.goToElement)}
        >
          {navButtonsData.map(({ title, elementGoTo }) => (
            <Text
              key={elementGoTo}
              data-go-to-element={elementGoTo}
              cursor="pointer"
              textStyle="header.h4"
              fontSize="18px"
              py="8px"
              transition="all .3s"
            >
              {title}
            </Text>
          ))}
        </VStack>
      </VStack>
    </Portal>
  );
};

export default MobileTableOfContents;

const Icon = ({ icon, iconProps = null, motionProps = null, ...props }) => (
  <motion.div
    style={{ cursor: 'pointer', padding: '0', position: 'absolute', zIndex: '2', ...props }}
    {...motionProps}
  >
    <NextImage w="full" h="full" src={icon} alt="arrow_icon" userSelect="none" {...iconProps} />
  </motion.div>
);
